'use-client';

import classNames from 'classnames';
import React from 'react';

/* ================================== TYPES ================================= */

export type TParameterSelectButtonProps = {
  icon: React.ReactNode; // Icon to display
  label: string; // Button label
  onPress: () => void; // Callback for button press
  isSelected: boolean; // State to determine if the button is selected
  useMargin?: boolean; // Whether to use margin
};

/* ========================================================================== */
/*                                  COMPONENT                                 */
/* ========================================================================== */
export function ParameterSelectButton({
  icon,
  label,
  onPress,
  isSelected,
  useMargin = true,
}: TParameterSelectButtonProps) {
  const buttonClasses = classNames(
    'flex',
    'flex-col',
    'items-start',
    'justify-between',
    'p-3',
    'md:p-5',
    'border',
    'rounded-lg',
    'focus:outline-none',
    'focus:ring-2',
    'transition-all',
    'duration-300',
    'md:w-[160px]',
    'md:h-[170px]',
    'w-[120px]',
    'h-[130px]',
    {
      'bg-white text-blue-500 border-transparent shadow-lg': isSelected,
      'bg-transparent text-white border-white hover:bg-white hover:bg-opacity-20 hover:shadow-lg':
        !isSelected,
      'm-2': useMargin,
    },
  );

  const labelClasses = classNames(
    'mt-2',
    'font-meyer',
    'text-lg',
    'md:text-xl',
    'lg:text-2xl',
    'text-left',
  );

  const iconClasses = classNames(
    'w-[40px]',
    'h-[40px]',
    'md:w-[60px]',
    'md:h-[60px]',
    'text-xl',
    'md:text-2xl',
  );

  return (
    <button
      onClick={onPress}
      className={buttonClasses}
      style={{
        userSelect: 'none',
        boxShadow: isSelected ? '0 0 50px rgba(255, 255, 255, 0.5)' : 'none',
      }}
    >
      <div className={iconClasses}>
        {icon &&
          React.cloneElement(icon, { className: 'text-2xl md:text-5xl' })}
      </div>
      <div className={labelClasses}>{label}</div>
    </button>
  );
}
